import { AnalyticsService } from 'base/analytics';
import { UnreachableError } from 'base/helpers';
import { useOnMount } from 'base/useOnMount';
import { maybeParseAcceptTeamInviteRoute } from 'blocks/accept_team_invite/routes';
import { maybeParseAuthRoute } from 'blocks/auth/routes';
import { currentUrl } from 'blocks/current_url';
import { maybeParseDashboardRoute } from 'blocks/dashboard/routes';
import { maybeParseManageAccountRoute } from 'blocks/manage_account/routes';
import { reaction } from 'mobx';

export function usePageViewEvent(analytics: AnalyticsService) {
  useOnMount(() =>
    reaction(
      () => currentUrl.pathname,
      (_, previousPath) => {
        let authRoute = maybeParseAuthRoute(currentUrl);

        if (authRoute != null) {
          switch (authRoute.path) {
            case 'upgrade':
              return analytics.track({
                event: 'upgrade_flow:upgrade_page_view',
                previous_path: previousPath,
              });
            case 'signup':
              return analytics.track({
                event: 'signup_flow:signup_page_view',
                previous_path: previousPath,
              });
            // TODO Add analytics of choose type usage
            case 'signup/verify-email':
            case 'signup/choose-plan':
            case 'signup/survey':
            case 'signup/invite-team':
            case 'forgot-password':
            case 'forgot-password/change-password':
            case 'forgot-password/verify-email':
            case 'login':
              break;
            default:
              new UnreachableError(authRoute);
          }
          return;
        }

        const manageAccountRoute = maybeParseManageAccountRoute(currentUrl);
        if (manageAccountRoute != null) {
          switch (manageAccountRoute.path) {
            case 'manage-account':
            case 'manage-account/plan':
            case 'manage-account/team': {
              break;
            }
            case 'manage-account/referral': {
              return analytics.track({
                event: 'manage-account:referral',
                previous_path: previousPath,
              });
            }
            default:
              new UnreachableError(manageAccountRoute);
          }
          return;
        }

        const acceptTeamInviteRoute =
          maybeParseAcceptTeamInviteRoute(currentUrl);
        if (acceptTeamInviteRoute != null) {
          switch (acceptTeamInviteRoute.path) {
            case 'accept-team-invite':
              break;
            default:
              new UnreachableError(acceptTeamInviteRoute.path);
          }
          return;
        }

        const dashboardRoute = maybeParseDashboardRoute(currentUrl);
        if (dashboardRoute != null) {
          switch (dashboardRoute.path) {
            case 'dashboard':
              return analytics.track({
                event: 'dashboard:dashboard_page_view',
                tab: dashboardRoute.projectsFilter,
                previous_path: previousPath,
              });
            default:
              new UnreachableError(dashboardRoute.path);
          }
          return;
        }
      },
      { fireImmediately: true },
    ),
  );
}
